"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeInfoContexto = exports.normalizeResponseOk = exports.normalizeBoolean = exports.normalizeUserName = exports.createBasicContext = exports.DEFAULT_RESPONSE = exports.isAplicacionesTelco = exports.isTelcoSite = void 0;
const next12_utils_common_1 = require("@gcloud-npm/next12.utils.common");
const isTelcoSite = () => {
    return window.location.href.indexOf("cliente/areaprivada/#") >= 0;
};
exports.isTelcoSite = isTelcoSite;
const isAplicacionesTelco = () => {
    if (window.location.href.indexOf("/particulares/Aplicaciones/Telco/procesoCompra/baf") >= 0) {
        return false;
    }
    if (window.location.href.indexOf("/particulares/Aplicaciones/Telco/procesoCompra/tarifaMovil") >= 0) {
        return false;
    }
    if (window.location.href.indexOf("/particulares/Aplicaciones/Telco/procesoCompra/tecuida") >= 0) {
        return false;
    }
    if (window.location.href.indexOf("/particulares/Aplicaciones/Telco/procesoCompra/formMan/") >= 0) {
        return false;
    }
    if (window.location.href.indexOf("/particulares/Aplicaciones/Telco/procesoCompra/miMovistar") >= 0) {
        return false;
    }
    if (window.location.href.indexOf("/particulares/Aplicaciones/Telco/procesoCompra/gamepass") >= 0) {
        return false;
    }
    if (window.location.href.indexOf("/particulares/Aplicaciones/Telco/procesoCompra/gamepass") >= 0) {
        return false;
    }
    return (window.location.href.indexOf("particulares/Aplicaciones/Telco/procesoCompra") >= 0);
};
exports.isAplicacionesTelco = isAplicacionesTelco;
exports.DEFAULT_RESPONSE = {
    contextVars: {
        userName: "",
        userPriority: false,
        userSecondaryType: "",
        userType: "", // este tiene que se estrictamente para el usuario
        businessName: "",
        userSegment: "",
        loggedById: false,
    },
    xCol4Hashes: "",
};
const TIPO = {
    TELCO: "telco",
    LEGADO_MOVIL: "legadomovil",
    LEGADO_FIJO: "legadofijo",
    LEGADO_CONVERGENTE: "legadoconvergente",
};
const createBasicContext = () => __awaiter(void 0, void 0, void 0, function* () {
    let basicContext = yield Promise.resolve().then(() => __importStar(require("@gcloud-npm/next12.utils.environment")));
    const environment = basicContext.findOutEnv();
    const context = {
        environment,
    };
    return context;
});
exports.createBasicContext = createBasicContext;
const decideUserType = (logado, tipo) => {
    let res = ""; // significa no logado en contexto
    const tipoNorm = tipo ? tipo.toLowerCase() : "";
    // Interpretando valores del servicio
    if (logado && tipoNorm) {
        if (tipoNorm.indexOf(TIPO.TELCO) > -1) {
            res = "Telco";
        }
        if (tipoNorm.indexOf(TIPO.LEGADO_MOVIL) > -1 ||
            tipoNorm.indexOf(TIPO.LEGADO_FIJO) > -1 ||
            tipoNorm.indexOf(TIPO.LEGADO_CONVERGENTE) > -1) {
            res = "Legado";
        }
    }
    // Interpretando Urls
    if ((0, exports.isTelcoSite)() || (0, exports.isAplicacionesTelco)()) {
        res = "Telco";
    }
    if ((0, next12_utils_common_1.getCookie)("TGES_LOGGED")) {
        res = "Gestor";
    }
    return res;
};
const normalizeError = (errores) => {
    // SEND TO front sonda with all errors
    Promise.resolve().then(() => __importStar(require("@gcloud-npm/next12.utils.front-sonda"))).then((frontSondaModule) => __awaiter(void 0, void 0, void 0, function* () {
        const sonda = new frontSondaModule.default({
            processName: "getInfoContextFromCCLI",
            filePath: "modules/ccli/normalizer",
            context: yield (0, exports.createBasicContext)(),
        });
        sonda.warningMessage({ info: JSON.stringify(errores) });
    }));
    return exports.DEFAULT_RESPONSE;
};
const normalizeUserName = (nombre, apellidos) => {
    let userName = "";
    if (nombre) {
        userName = `${nombre}`;
        if (apellidos) {
            userName = `${userName} ${apellidos}`;
        }
    }
    return userName;
};
exports.normalizeUserName = normalizeUserName;
const normalizeBoolean = (boolData) => {
    let res = false;
    if (boolData) {
        res = true;
    }
    return res;
};
exports.normalizeBoolean = normalizeBoolean;
const normalizeResponseOk = (infocontexto) => {
    try {
        const { logado, tipo, nombre, apellidos, priority, secundario, razonSocial, segmento, auth, tpoIdentificador, xcol, } = infocontexto;
        const userType = decideUserType(logado, tipo);
        const contextVars = {
            userName: (0, exports.normalizeUserName)(nombre, apellidos),
            userPriority: (0, exports.normalizeBoolean)(priority),
            userSecondaryType: tipo || "",
            userType,
            businessName: razonSocial || "",
            userSegment: segmento || "",
            loggedById: !(0, exports.normalizeBoolean)(secundario),
            userAuth: auth || "",
            tipoIdentificador: tpoIdentificador || "",
        };
        const xCol4Hashes = xcol || "";
        // const userSegment =
        return {
            xCol4Hashes,
            contextVars,
        };
    }
    catch (error) {
        // TODO SONDAR
        Promise.resolve().then(() => __importStar(require("@gcloud-npm/next12.utils.front-sonda"))).then((frontSondaModule) => __awaiter(void 0, void 0, void 0, function* () {
            const sonda = new frontSondaModule.default({
                processName: "normalizeResponseOk",
                filePath: "modules/ccli/normalizer",
                context: yield (0, exports.createBasicContext)(),
            });
            sonda.warningMessage({ info: null, error });
        }));
        return exports.DEFAULT_RESPONSE;
    }
};
exports.normalizeResponseOk = normalizeResponseOk;
const normalizeInfoContexto = (rawData) => {
    let result = exports.DEFAULT_RESPONSE;
    // si tiene campo response
    if (rawData && rawData.exito && rawData.errores) {
        let { exito, errores, datos, datoObsoleto } = rawData;
        const isOk = datos &&
            datos.infocontexto &&
            !datoObsoleto &&
            exito &&
            errores &&
            Array.isArray(errores) &&
            errores.length === 0;
        if (!isOk) {
            return normalizeError(errores);
        }
        result = (0, exports.normalizeResponseOk)(datos.infocontexto);
    }
    return result;
};
exports.normalizeInfoContexto = normalizeInfoContexto;
//# sourceMappingURL=index.js.map